import { apiGet, apiPost } from '@/features/shared/utils/dataFetching'
import { API_URL } from '@/features/shared/utils/dataFetching/apiUrl'
import { type QueryFunctionContext } from '@tanstack/react-query'
import {
  type RegulationCategoryStateAndReason,
  type OptoutRestrictionsResponse,
  type OptOutRestriction,
} from '@/features/account/services/DataPrivacy/types'
import { type OptoutRestrictionsQueryKey } from '@/features/account/services/DataPrivacy/queries'
import { isOnServer } from '@shared/constants/util'

export const fetchHandleOptOutCookies = (data?: RegulationCategoryStateAndReason) =>
  apiPost({
    config: { url: '/opt-out', data },
    options: { apiUrl: API_URL.SELF_API },
    fetcherName: 'fetchHandleOptOutCookies',
  })

// this API call should be made on the client side only
export const fetchOptOutRestrictions = async (
  context: QueryFunctionContext<OptoutRestrictionsQueryKey>,
): Promise<OptOutRestriction | null> => {
  const { state, zip_code } = context.queryKey[1]

  try {
    const restrictionsResponse = await apiGet<OptoutRestrictionsResponse | void>({
      config: {
        url: '/data-rights/v1/privacy-compliance/opt-out-restrictions/',
        params: {
          state,
          zip_code,
        },
      },
      context,
      fetcherName: 'fetchOptOutRestrictions',
    })

    const restrictions =
      typeof restrictionsResponse === 'object' ? restrictionsResponse.restrictions : []

    const restrictionObject = restrictions.find((r) => {
      return r.active && r.opt_out === 'do_not_share_sell_ta'
    })

    if (restrictionObject) {
      await setClientOptOutState({
        regulation_category: restrictionObject.regulation_category,
        regulation_reason: restrictionObject.regulation_reason,
        regulation_state: restrictionObject.regulation_state,
      })
    }

    return restrictionObject ?? null
  } catch (e) {
    await setClientOptOutState({
      regulation_category: '',
      regulation_reason: 'service_error',
      regulation_state: '',
    })
    throw e
  }
}

export const setClientOptOutState = async (params?: RegulationCategoryStateAndReason) => {
  if (isOnServer()) return
  window.SHIPT_DO_NOT_SHARE_SELL_TA = true

  await fetchHandleOptOutCookies(params)
}
